/**
 * Navigation Component
 */

import { getLanguage, setLanguage, t } from '../lib/i18n.js';
import { getCurrentUser, isAuthenticated, login, logout } from '../lib/keycloak.js';

export async function createNavigation() {
  const nav = document.createElement('nav');
  nav.className = 'nav';

  const currentPath = window.location.pathname;
  const currentLang = getLanguage();
  const authenticated = isAuthenticated();

  let userSection = '';
  if (authenticated) {
    const user = await getCurrentUser();
    const userName = normalizeDisplayText(user?.name || user?.email || 'User');
    userSection = `
      <li class="nav-user">
        <span class="nav-user-name">${escapeHtml(userName)}</span>
        <button class="nav-logout-btn" id="logout-btn">Sign Out</button>
      </li>
    `;
  } else {
    // Hide Sign In button for now
    userSection = '';
  }

  nav.innerHTML = `
    <div class="nav-content">
      <a href="/" class="nav-logo" data-link>
        <img src="/Stroyma_White_transparent.png" alt="Stroyma">
      </a>
      
      <button class="nav-burger" id="nav-burger" aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      <ul class="nav-links" id="nav-links">
        <li>
          <a href="/browse?category=documentary" class="nav-link ${window.location.search.includes('category=documentary') || (currentPath === '/browse' && !window.location.search) ? 'active' : ''}" data-link>
            ${t('nav_documentary')}
          </a>
        </li>
        <li>
          <a href="/browse?category=short" class="nav-link ${window.location.search.includes('category=short') ? 'active' : ''}" data-link>
            ${t('nav_short_film')}
          </a>
        </li>
        <li>
          <a href="/browse?category=feature" class="nav-link ${window.location.search.includes('category=feature') ? 'active' : ''}" data-link>
            ${t('nav_feature_film')}
          </a>
        </li>
        ${
          authenticated
            ? `
        <li>
          <a href="/my-rentals" class="nav-link ${currentPath === '/my-rentals' ? 'active' : ''}" data-link>
            ${t('nav_my_rentals')}
          </a>
        </li>
        `
            : ''
        }
        <li class="nav-search-link">
          <a href="/search" class="nav-link ${currentPath === '/search' ? 'active' : ''}" data-link>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px; vertical-align: middle;">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            ${t('nav_search') || 'Search'}
          </a>
        </li>
        <li class="nav-language-switcher">
          <button class="nav-lang-btn ${currentLang === 'fo' ? 'active' : ''}" data-lang="fo">FO</button>
          <button class="nav-lang-btn ${currentLang === 'en' ? 'active' : ''}" data-lang="en">EN</button>
        </li>
        ${userSection}
      </ul>
    </div>
  `;

  // Add burger menu toggle
  const burger = nav.querySelector('#nav-burger');
  const navLinks = nav.querySelector('#nav-links');

  burger.addEventListener('click', () => {
    burger.classList.toggle('active');
    navLinks.classList.toggle('active');
    document.body.classList.toggle('nav-open');
  });

  // Close mobile menu when clicking a link or search button
  nav.querySelectorAll('[data-link]').forEach((link) => {
    link.addEventListener('click', () => {
      burger.classList.remove('active');
      navLinks.classList.remove('active');
      document.body.classList.remove('nav-open');
    });
  });

  // Add language switcher handlers
  nav.querySelectorAll('[data-lang]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const lang = e.target.dataset.lang;
      setLanguage(lang);
      // Close mobile menu after language change
      burger.classList.remove('active');
      navLinks.classList.remove('active');
      document.body.classList.remove('nav-open');
    });
  });

  // Add login/logout handlers
  const loginBtn = nav.querySelector('#login-btn');
  const logoutBtn = nav.querySelector('#logout-btn');

  if (loginBtn) {
    loginBtn.addEventListener('click', () => login());
  }

  if (logoutBtn) {
    logoutBtn.addEventListener('click', () => logout());
  }

  return nav;
}

function normalizeDisplayText(value) {
  return String(value).normalize('NFC');
}

function escapeHtml(value) {
  return value.replace(/[&<>"']/g, (char) => {
    const entities = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };

    return entities[char];
  });
}
